import React from 'react';
import head from 'lodash/head';
import { useSelector } from 'react-redux';
import { PRICE_EXTRA_INFORMATION, PRICE_HERO_INFORMATION } from '@yme/common/constants';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getCommon } from '@yme/selectors/common';
import { getAttribute, getProductDetailsVariantsWithGroupingProducts, } from '@yme/selectors/products';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { formatPrice } from '@yme/utils/formatPrice';
import { AmountStyled, CreditStyled, PriceHeroInformationStyled, PriceStyled, PriceSubtitleStyled, } from '../styled';
export function HeroPrice({ fromLabel, showYouFinance = true }) {
    const { language, youFinanceText: priceExtraInfo, priceHeroInfo, isRightToLeft, } = useSelector(getCommon);
    const { isTabletView } = useWindowSize();
    const productVariants = useSelector(getProductDetailsVariantsWithGroupingProducts) ?? [];
    const youFinanceText = useSelector(getAttribute(PRICE_EXTRA_INFORMATION)) || priceExtraInfo;
    const priceHeroInformation = useSelector(getAttribute(PRICE_HERO_INFORMATION)) || priceHeroInfo;
    const lowestPrice = productVariants?.reduce((acc, variant) => {
        const priceAttribute = head(variant.prices);
        if (!priceAttribute) {
            return acc;
        }
        const price = priceAttribute?.discount?.discountedPrice || priceAttribute?.amount || Infinity;
        return price < acc ? price : acc;
    }, Infinity);
    const variantWithLowestPrice = productVariants?.find((item) => head(item.prices)?.amount === lowestPrice ||
        head(item.prices)?.discount?.discountedPrice === lowestPrice);
    const priceAttribute = head(variantWithLowestPrice?.prices);
    const price = lowestPrice;
    const currencyCode = priceAttribute?.currencyCode;
    if (!price || !isFinite(price)) {
        return null;
    }
    const formattedPrice = formatPrice({
        locale: language,
        currencyName: currencyCode,
        price,
    });
    return (React.createElement(PriceStyled, null,
        React.createElement(PriceSubtitleStyled, null, fromLabel),
        React.createElement(AmountStyled, { isRightToLeft: isRightToLeft }, formattedPrice),
        youFinanceText && showYouFinance && React.createElement(CreditStyled, null, youFinanceText),
        priceHeroInformation && showYouFinance && (React.createElement(FlexWrapper, { pt: isTabletView ? '16px' : '24px' },
            React.createElement(PriceHeroInformationStyled, null, priceHeroInformation)))));
}
HeroPrice.displayName = 'HeroPrice_Component';
